"use strict";
/*
 * Copyright (C) 2021 JET PROTOCOL HOLDINGS, LLC.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionInfoStructList = exports.PositionInfoStruct = exports.MarketReserveInfoStructList = exports.ReserveInfoStruct = exports.ReserveStateStruct = exports.MAX_RESERVES = void 0;
const BL = __importStar(require("@solana/buffer-layout"));
const accountParser_1 = require("../common/accountParser");
const util_1 = require("./util");
exports.MAX_RESERVES = 32;
exports.ReserveStateStruct = BL.struct([
    (0, util_1.i64Field)("accruedUntil"),
    (0, accountParser_1.numberField)("outstandingDebt"),
    (0, accountParser_1.numberField)("uncollectedFees"),
    (0, accountParser_1.u64Field)("totalDeposits"),
    (0, accountParser_1.u64Field)("totalDepositNotes"),
    (0, accountParser_1.u64Field)("totalLoanNotes"),
    BL.blob(416, "_UNUSED_0_"),
    (0, accountParser_1.u64Field)("lastUpdated"),
    BL.u8("invalidated"),
    BL.blob(7, "_UNUSED_1_")
]);
exports.ReserveInfoStruct = BL.struct([
    (0, accountParser_1.pubkeyField)("reserve"),
    BL.blob(80, "_UNUSED_0_"),
    (0, accountParser_1.numberField)("price"),
    (0, accountParser_1.numberField)("depositNoteExchangeRate"),
    (0, accountParser_1.numberField)("loanNoteExchangeRate"),
    (0, accountParser_1.numberField)("minCollateralRatio"),
    BL.u16("liquidationBonus"),
    BL.blob(158, "_UNUSED_1_"),
    (0, accountParser_1.u64Field)("lastUpdated"),
    BL.u8("invalidated"),
    BL.blob(7, "_UNUSED_2_")
]);
exports.MarketReserveInfoStructList = BL.seq(exports.ReserveInfoStruct, exports.MAX_RESERVES);
exports.PositionInfoStruct = BL.struct([
    (0, accountParser_1.pubkeyField)("account"),
    (0, accountParser_1.numberField)("amount"),
    BL.u32("side"),
    BL.u16("reserveIndex"),
    BL.blob(66, "_reserved")
]);
exports.PositionInfoStructList = BL.seq(exports.PositionInfoStruct, 16, "positions");
//# sourceMappingURL=layout.js.map